import React from 'react';

import { makeClassNames } from '../../../utils/styles';
import Tooltip from '../../atoms/tooltip/tooltip';

import './match-trend.scss';

interface IMatchTrendTeam {
  name: string;
  goal: number;
}
export interface IMatchTrendItem {
  label: string;
  home: IMatchTrendTeam;
  away: IMatchTrendTeam;
}

export interface IMatchTrend {
  lastMatchesTrend: IMatchTrendItem[];
  limit?: number;
}

const classNames = () => {
  return makeClassNames({
    div: 'match-trend',
    span: 'match-trend__span',
    tooltip: 'match-trend__tooltip',
    tooltipText: 'match-trend__tooltip-text',
    tooltipScore: 'match-trend__tooltip-score',
  });
};

const MatchTrend = ({ lastMatchesTrend, limit = 0 }: IMatchTrend) => {
  const cn = classNames();
  const slicedMatchTrend = limit ? lastMatchesTrend.slice(0, limit) : lastMatchesTrend;
  return (
    <div className={cn.div}>
      {slicedMatchTrend.map((item: IMatchTrendItem) => {
        const id = item.home.name + item.away.name;
        const tooltip = (
          <span className={cn.tooltipText}>
            {item.home.name}
            <span className={cn.tooltipScore}>
              {item.home.goal} - {item.away.goal}
            </span>
            {item.away.name}
          </span>
        );

        return (
          <Tooltip key={id} className={cn.tooltip} text={tooltip}>
            <span key={id} className={cn.span} data-state={item.label}>
              {item.label}
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default MatchTrend;
